import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex'
import {
  CHANNEL_LIST
} from '../vuex/mutation-types.js'
import {config} from '../config'
import Cookies from 'js-cookie'

// 登陆
const login = () => import('@/views/login/index')
// 布局
const home = () => import('@/views/home')
// 首页
const homeIndex = () => import('@/views/home/index')
const news = () => import('@/views/news/create')
const video = () => import('@/views/video/create')
const slide = () => import('@/views/slide/create')
const link = () => import('@/views/link/create')
const live = () => import('@/views/live/create')
const search = () => import('@/views/news/search')
const plans = () => import('@/views/news/plans')
const revokes = () => import('@/views/news/revokes')
const newsIndex = () => import('@/views/news/index')
const editNews = () => import('@/views/news/edit')
const editVideo = () => import('@/views/video/edit')
const editSlide = () => import('@/views/slide/edit')
const editLink = () => import('@/views/link/edit')
const editLive = () => import('@/views/live/edit')
const channel = () => import('@/views/channel/index')
const channelList = () => import('@/views/channel/list')
const error = () => import('@/views/common/error')
const signature = () => import('@/views/signature/index')
const userList = () => import('@/views/user/list')
const userCreate = () => import('@/views/user/create')
const appList = () => import('@/views/app/list')
const appCreate = () => import('@/views/app/create')
const otherReg = () => import('@/views/other/reg')
const courseCategory = () => import('@/views/course/category')
const courseChapter = () => import('@/views/course/chapter')
const courseList = () => import('@/views/course/list')
const courseFile = () => import('@/views/course/file')
// const courseComment = () => import('@/views/course/comment')
// const courseQuestion = () => import('@/views/course/question')
// const courseTask = () => import('@/views/course/task')
const courseStudy = () => import('@/views/course/study')
// const courseStudyTask = () => import('@/views/course/studytask')
const questionList = () => import('@/views/question/list')
const questionBankCategory = () => import('@/views/question/category')
const questionBankList = () => import('@/views/question/bank')
const questionBankStudy = () => import('@/views/question/study')
const questionScore = () => import('@/views/question/score')
const questionCorrection = () => import('@/views/question/correction')
const examList = () => import('@/views/question/exam')
const orderList = () => import('@/views/order/list')
const orderPackage = () => import('@/views/order/package')

// 管理员应用ID
const adminAppID = config.admin_app_id
const currentAppID = parseInt(Cookies.get('appid'))
let channels = []
// 全局路由
let routes = [{
  path: '/error',
  name: 'error',
  meta: {
    zhName: '错误',
    key: 'error'
  },
  component: error
}, {
  path: '/login',
  name: 'login',
  meta: {
    zhName: '登录',
    key: 'login'
  },
  component: login
}, {
  path: '/',
  name: 'default',
  redirect: '/home',
  meta: {
    zhName: '主页',
    key: 'default'
  },
  component: home
}, {
  path: '/#separator0',
  name: 'separator0',
  component: home,
  isNest: false,
  meta: {
    zhName: '工作台',
    key: 'separator0'
  },
  children: [{
    path: '#',
    name: 'separator_index0',
    meta: {
      zhName: '工作台',
      key: 'separator_index0'
    },
    component: homeIndex
  }]
}, {
  path: '/home',
  name: 'home',
  component: home,
  isNest: false,
  redirect: '/home/index',
  meta: {
    zhName: '概览',
    key: 'home'
  },
  children: [{
    path: '/home/index',
    name: 'home_index',
    icon: 'el-icon-view',
    meta: {
      zhName: '概览',
      key: 'home_index'
    },
    component: homeIndex
  }]
}]
if (currentAppID === adminAppID) {
  // 添加管理员应用路由
  routes = routes.concat([
    {
      path: '/app',
      name: 'app',
      isNest: true,
      icon: 'el-icon-menu',
      component: home,
      meta: {
        zhName: '应用管理',
        key: 'app'
      },
      children: [{
        path: '/app/list',
        name: 'app_list',
        component: appList,
        meta: {
          zhName: '应用列表',
          key: 'app_list'
        }
      }, {
        path: '/app/create',
        name: 'app_create',
        component: appCreate,
        meta: {
          zhName: '创建应用',
          key: 'app_create'
        }
      }]
    }, {
      path: '/user',
      name: 'user',
      isNest: true,
      icon: 'el-icon-user',
      component: home,
      meta: {
        zhName: '帐号管理',
        key: 'user'
      },
      children: [{
        path: '/user/list',
        name: 'user_list',
        component: userList,
        meta: {
          zhName: '帐号列表',
          key: 'user_list'
        }
      }, {
        path: '/user/create',
        name: 'user_create',
        component: userCreate,
        meta: {
          zhName: '创建帐号',
          key: 'user_create'
        }
      }]
    }
  ])
} else {
  // 添加其它应用路由
  routes = routes.concat([
    {
      path: '/newslist',
      name: 'newslist',
      isNest: true,
      icon: 'el-icon-share',
      component: home,
      meta: {
        zhName: '内容分类',
        key: 'newslist'
      },
      children: [{
        path: '/newslist/plans',
        name: 'newslist_plans',
        component: plans,
        meta: {
          zhName: '计划任务队列',
          key: 'newslist_plans'
        }
      }, {
        path: '/newslist/revokes',
        name: 'newslist_revokes',
        component: revokes,
        meta: {
          zhName: '主编撤稿记录',
          key: 'newslist_revokes'
        }
      }]
    }, {
      path: '/operate',
      name: 'operate',
      isNest: true,
      icon: 'el-icon-setting',
      component: home,
      meta: {
        zhName: '运营管理',
        key: 'operate'
      },
      children: [/*{
        path: '/operate/signature',
        name: 'operate_signature',
        component: signature,
        meta: {
          zhName: '署名库',
          key: 'operate_signature'
        }
      }, */{
        path: '/operate/channel',
        name: 'operate_channel',
        component: channelList,
        meta: {
          zhName: '频道管理',
          key: 'operate_channel'
        }
      }]
    }, {
      path: '/create',
      name: 'create',
      isNest: true,
      icon: 'el-icon-document',
      component: home,
      meta: {
        zhName: '内容生产',
        key: 'create'
      },
      children: [{
        path: '/create/news',
        name: 'create_news',
        component: news,
        meta: {
          zhName: '发布资源',
          key: 'create_news'
        }
      }, {
        path: '/news/search',
        name: 'news_search',
        component: search,
        meta: {
          zhName: '资源搜索',
          key: 'news_search'
        }
      }]
    }, {
      path: '/other',
      name: 'other',
      isNest: true,
      icon: 'el-icon-news',
      component: home,
      meta: {
        zhName: '用户管理',
        key: 'other'
      },
      children: [{
        path: '/other/reg',
        name: 'other_reg',
        component: otherReg,
        meta: {
          zhName: '用户列表',
          key: 'other_reg'
        }
      }]
    }, {
      path: '/course',
      name: 'course',
      isNest: true,
      icon: 'el-icon-notebook-2',
      component: home,
      meta: {
        zhName: '课程管理',
        key: 'course'
      },
      children: [{
        path: '/course/category',
        name: 'course_category',
        component: courseCategory,
        meta: {
          zhName: '课程分类',
          key: 'course_category'
        }
      }, {
        path: '/course/list',
        name: 'course_list',
        component: courseList,
        meta: {
          zhName: '课程列表',
          key: 'course_list'
        }
      }, {
        path: '/course/chapter',
        name: 'course_chapter',
        component: courseChapter,
        meta: {
          zhName: '课程章节',
          key: 'course_chapter'
        }
      }, {
        path: '/course/file',
        name: 'course_file',
        component: courseFile,
        meta: {
          zhName: '课程资料',
          key: 'course_file'
        }
      }, {
        path: '/course/study',
        name: 'course_study',
        component: courseStudy,
        meta: {
          zhName: '参课人员',
          key: 'course_study'
        }
      }/*, {
        path: '/course/comment',
        name: 'course_comment',
        component: courseComment,
        meta: {
          zhName: '课程评价',
          key: 'course_comment'
        }
      }, {
        path: '/course/question',
        name: 'course_question',
        component: courseQuestion,
        meta: {
          zhName: '课程提问',
          key: 'course_question'
        }
      }, {
        path: '/course/task',
        name: 'course_task',
        component: courseTask,
        meta: {
          zhName: '课程任务',
          key: 'course_task'
        }
      }, {
        path: '/course/studytask',
        name: 'course_studytask',
        component: courseStudyTask,
        meta: {
          zhName: '参课任务',
          key: 'course_studytask'
        }
      } */]
    }, {
      path: '/question',
      name: 'question',
      isNest: true,
      icon: 'el-icon-reading',
      component: home,
      meta: {
        zhName: '题库管理',
        key: 'question'
      },
      children: [{
        path: '/question/category',
        name: 'question_category',
        component: questionBankCategory,
        meta: {
          zhName: '题库分类',
          key: 'question_category'
        }
      }, {
        path: '/question/bank',
        name: 'question_bank',
        component: questionBankList,
        meta: {
          zhName: '题库列表',
          key: 'question_bank'
        }
      }, {
        path: '/question/list',
        name: 'question_list',
        component: questionList,
        meta: {
          zhName: '题目列表',
          key: 'question_list'
        }
      }, {
        path: '/question/exam',
        name: 'question_exam',
        component: examList,
        meta: {
          zhName: '考试列表',
          key: 'exam_list'
        }
      }, {
        path: '/question/study',
        name: 'question_study',
        component: questionBankStudy,
        meta: {
          zhName: '学习人员',
          key: 'question_study'
        }
      }, {
        path: '/question/score',
        name: 'question_score',
        component: questionScore,
        meta: {
          zhName: '成绩列表',
          key: 'question_score'
        }
      }, {
        path: '/question/correction',
        name: 'question_correction',
        component: questionCorrection,
        meta: {
          zhName: '纠错列表',
          key: 'question_correction'
        }
      }]
    }, {
      path: '/order',
      name: 'order',
      isNest: true,
      icon: 'el-icon-wallet',
      component: home,
      meta: {
        zhName: '充值管理',
        key: 'order'
      },
      children: [{
        path: '/order/list',
        name: 'order_list',
        component: orderList,
        meta: {
          zhName: '充值订单',
          key: 'order_list'
        }
      }, {
        path: '/order/package',
        name: 'order_package',
        component: orderPackage,
        meta: {
          zhName: '积分套餐',
          key: 'order_package'
        }
      }]
    }, {
      path: '/#separator1',
      name: 'separator1',
      component: home,
      isNest: false,
      meta: {
        zhName: '频道',
        key: 'separator1'
      },
      children: [{
        path: '#',
        name: 'separator_index1',
        meta: {
          zhName: '频道',
          key: 'separator_index1'
        },
        component: homeIndex
      }]
    }, {
      path: '/channel/:id',
      name: 'channel',
      component: home,
      meta: {
        zhName: '频道',
        key: 'channel'
      },
      children: [{
        path: '/channel/:id',
        name: 'channel_index',
        meta: {
          zhName: '频道',
          key: 'channel_index'
        },
        component: channel
      }]
    }, {
      path: '/edit',
      name: 'edit',
      icon: 'el-icon-document',
      component: home,
      meta: {
        zhName: '内容生产',
        key: 'edit'
      },
      children: [{
        path: '/edit/news/:id',
        name: 'edit_news',
        component: editNews,
        meta: {
          zhName: '编辑稿件',
          key: 'edit_news'
        }
      }, {
        path: '/edit/video/:id',
        name: 'edit_video',
        component: editVideo,
        meta: {
          zhName: '编辑视频',
          key: 'edit_video'
        }
      }, {
        path: '/edit/slide/:id',
        name: 'edit_slide',
        component: editSlide,
        meta: {
          zhName: '编辑图集',
          key: 'edit_slide'
        }
      }, {
        path: '/edit/link/:id',
        name: 'edit_link',
        component: editLink,
        meta: {
          zhName: '编辑外链',
          key: 'edit_link'
        }
      }, {
        path: '/edit/live/:id',
        name: 'edit_live',
        component: editLive,
        meta: {
          zhName: '编辑直播',
          key: 'edit_live'
        }
      }]
    }, {
      path: '/news/:type/:id',
      name: 'news',
      component: home,
      meta: {
        zhName: '资源',
        key: 'news'
      },
      children: [{
        path: '/news/:type/:id',
        name: 'news_index',
        meta: {
          zhName: '资源',
          key: 'news_index'
        },
        component: newsIndex
      }]
    }
  ])
}

if (currentAppID > 0 && currentAppID !== adminAppID) {
  store.dispatch('getChannels', {AppID: currentAppID, pageNum: 1, pageSize: 1000}).then(response => {
    if (response.data.count > 0) {
      const list = response.data.data
      let k = 0
      for (let i = 0; i < list.length; i++) {
        if (list[i]['ChannelRoot'] === 0) {
          channels.push(
            {
              id: list[i]['ChannelID'],
              name: list[i]['ChannelName'],
              children: []
            }
          )
          for (let j = 0; j < list.length; j++) {
            if (list[j]['ChannelRoot'] === list[i]['ChannelID']) {
              channels[k]['children'].push(
                {
                  id: list[j]['ChannelID'],
                  name: list[j]['ChannelName'],
                  countToday: list[j]['CountToday']
                }
              )
            }
          }
          k++
        }
      }
      store.commit(CHANNEL_LIST, list)
    }
    // if (response.data === '' || JSON.stringify(response.data) === '{}') {
    //   store.commit('USER_INFO', response.data)
    // }

    for (let i = 0; i < channels.length; i++) {
      let node = {
        path: '/channel/' + channels[i]['id'],
        name: 'channel_' + channels[i]['id'],
        isNest: true,
        icon: 'el-icon-time',
        component: home,
        meta: {
          zhName: channels[i]['name'],
          key: 'channel_' + channels[i]['id']
        },
        children: []
      }
      for (let j = 0; j < channels[i]['children'].length; j++) {
        node['children'].push(
          {
            path: '/channel/' + channels[i]['children'][j]['id'],
            name: 'channel_' + channels[i]['children'][j]['id'],
            component: channel,
            meta: {
              zhName: channels[i]['children'][j]['name'],
              key: 'channel_' + channels[i]['children'][j]['id'],
              countToday: channels[i]['children'][j]['countToday']
            }
          }
        )
      }
      // routes.push(node)
    }
  })
}

Vue.use(Router)
export default new Router({
  // base: '/',
  mode: 'history',
  routes: routes
})
